module.exports = __webpack_public_path__ + "img/stats-network-multi-serv.73b0d926.svg";